export const GET_DATA = 'GET_DATA';
export const GET_DATA_FAIL = 'GET_DATA_FAIL';
export const CHANGE_VIEW = 'CHANGE_VIEW';
export const CHANGE_SUB_VIEW = 'CHANGE_SUB_VIEW';

export const LANDING_PAGE = 'LANDING_PAGE';
export const REGISTRATION_FORM = 'REGISTRATION_FORM';
export const REGISTRATION_WITH_ACCOUNT = 'REGISTRATION_WITH_ACCOUNT';
export const REGISTRATION_WITHOUT_ACCOUNT = 'REGISTRATION_WITHOUT_ACCOUNT';
export const REGISTRATION_CONFIRM_ACCOUNT = 'REGISTRATION_CONFIRM_ACCOUNT';


export const POST_DATA = 'POST_DATA';
export const POST_DATA_FAIL = 'POST_DATA_FAIL';
export const POST_DATA_FINAL = 'POST_DATA_FINAL';
export const POST_DATA_FINAL_FAIL = 'POST_DATA_FINAL_FAIL';
export const POST_IATA_AGENT_DATA = 'POST_IATA_AGENT_DATA';
export const POST_IATA_AGENT_DATA_FAIL = 'POST_IATA_AGENT_DATA_FAIL';
export const POST_QF_CUSTOMER_DATA = 'POST_QF_CUSTOMER_DATA';
export const POST_QF_CUSTOMER_DATA_FAIL = 'POST_QF_CUSTOMER_DATA_FAIL';

export const GET_COLLEAGUE_DATA = 'GET_COLLEAGUE_DATA';
export const GET_COLLEAGUE_DATA_FAIL = 'GET_COLLEAGUE_DATA_FAIL';
export const GET_USER_STATUS = 'GET_USER_STATUS';
export const GET_DATA_PERSONAL = 'GET_DATA_PERSONAL';
export const GET_DATA_PRIMARY = 'GET_DATA_PRIMARY';
export const GET_DATA_SECONDARY = 'GET_DATA_SECONDARY';
export const GET_COUNTRY_DATA = 'GET_COUNTRY_DATA';
export const GET_USER_REGISTRATION = 'GET_USER_REGISTRATION';

export const UPDATE_DATA_PRIMARY = 'UPDATE_DATA_PRIMARY';
export const UPDATE_DATA_PERSONAL = 'UPDATE_DATA_PERSONAL';
export const UPDATE_ADDITIONAL_INFO = 'UPDATE_ADDITIONAL_INFO';
export const UPDATE_ADDITIONAL_INFO_FINAL = 'UPDATE_ADDITIONAL_INFO_FINAL';
export const UPDATE_COMPANY_SETTINGS = 'UPDATE_COMPANY_SETTINGS';

export const DELETE_DATA = 'DELETE_DATA';
export const DATA_REFRESH_FLAG = 'DATA_REFRESH_FLAG';

export const SET_VALUE = "SET_VALUE";
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';
export const SYSTEM_FAIL = 'SYSTEM_FAIL';

export const RESET_COMPANY_DETAILS = 'RESET_COMPANY_DETAILS';
export const RESET_USER_DETAILS = 'RESET_USER_DETAILS';

export const USER_FUNCTION_SUCCESS = 'USER_FUNCTION_SUCCESS';
export const USER_FUNCTION_SUCCESS_MANAGE = 'USER_FUNCTION_SUCCESS_MANAGE';
export const COMPANY_SETTINGS = 'COMPANY_SETTINGS';
export const USER_COMPANY_SETTINGS = 'USER_COMPANY_SETTINGS';
export const USER_COMPANY_SETTINGS_SUCCESS_WITHOUT_RELOAD = 'USER_COMPANY_SETTINGS_SUCCESS_WITHOUT_RELOAD';

export const CHANGE_PASSWORD_SCREEN = 'CHANGE_PASSWORD_SCREEN';

export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL';
export const RESET_PASSWORD_SUCCESS_SCREEN = 'RESET_PASSWORD_SUCCESS_SCREEN';
export const RESET_PASSWORD_SCREEN = 'RESET_PASSWORD_SCREEN';
export const SEND_EMAIL_SUCCESS_SCREEN = 'SEND_EMAIL_SUCCESS_SCREEN';
export const SEND_EMAIL_SCREEN = 'SEND_EMAIL_SCREEN';
export const DROPDOWN_SELECT = 'DROPDOWN_SELECT';
export const SHOW_SUCCESS_MESSAGE = "SHOW_SUCCESS_MESSAGE";
export const REMOVE_CURRENT_ERROR = 'REMOVE_CURRENT_ERROR';
export const REMOVE_CURRENT_SUCCESS_AUTHORISE = 'REMOVE_CURRENT_SUCCESS_AUTHORISE';
export const REMOVE_CURRENT_SUCCESS_MANAGE = 'REMOVE_CURRENT_SUCCESS_MANAGE';
export const GET_PASSWORD_TOKEN_SUCCESS = 'GET_PASSWORD_TOKEN_SUCCESS';
export const GET_PASSWORD_TOKEN_FAIL = 'GET_PASSWORD_TOKEN_FAIL';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';

export const ACTIVATE_TAB = 'ACTIVATE_TAB';
export const LOAD_MORE_DATA = 'LOAD_MORE_DATA';
export const GET_ADDITIONAL_INFO = 'GET_ADDITIONAL_INFO';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const SEARCH_COMPANIES = 'SEARCH_COMPANIES';
export const SEARCH_COMPANIES_ALL = 'SEARCH_COMPANIES_ALL';
export const SET_FUNCTIONALITY = 'SET_FUNCTIONALITY';

export const FUNCTIONS_HEADING = 'Functions';
export const DELIVERY_OPTIONS_HEADING = 'Delivery options';
export const NOTIFICATIONS_HEADING = 'Notifications';
export const INTERNATIONAL_FUNCTION_HEADING = 'International functions';
export const DOMESTIC_FUNCTION_HEADING = 'Domestic functions';
export const ADMINISTRATION_FUNCTION_HEADING = 'Administration functions';
export const GROUP_MEMBERSHIP_HEADING = 'Group membership';
export const AUTHORISE_USER_FUNCTIONALITIES = 'Authorise user - functionalities';
export const MANAGE_USER_FUNCTIONALITIES = 'Manage user - functionalities';
export const EDIT_PERSONAL_INFORMATION = 'Edit personal information';
export const EDIT_PRIMARY_COMPANY = 'Edit primary company';
export const MANAGE_USER = 'Manage user';
export const EDIT_DETAILS = 'Edit details';
export const AUTHORISE = 'Authorise user - validate user and customer';
export const NO_DATA_AVAILABLE_AUTHORISE = "There are no registered users here yet.";
export const NO_DATA_AVAILABLE_MANAGE = "There is no data available";

export const PAGINATION_SIZE = 25;

export const SEARCH_SECONDARY_COMPANY = 'SEARCH_SECONDARY_COMPANY';
export const ADD_SECONDARY_COMPANY_SUCCESS = 'ADD_SECONDARY_COMPANY_SUCCESS';
export const ADD_SECONDARY_COMPANY_FAILURE = 'ADD_SECONDARY_COMPANY_FAILURE';
export const ADD_SECONDARY_COMPANY_ERROR = 'You cannot add TMPPORCUS/INTPORCUS as secondary companies.';
export const ADD_SECONDARY_COMPANY_DUP_ERROR = "Company is currently listed. Please provide another."
export const ADD_COMPANY = "ADD COMPANY";
export const SECONDARY_COMPANY = "SECONDARY COMPANY";
export const SECONDARY_SET_FUNCTIONALITY = "SET FUNCTIONALITY";
export const DELETE_SECONDARY_INFO_DATA = 'DELETE_SECONDARY_INFO_DATA';
export const LOAD_MORE_AUTHORISE_DATA = 'LOAD_MORE_AUTHORISE_DATA';
export const LOAD_MORE_MANAGE_USERS_DATA = 'LOAD_MORE_MANAGE_USERS_DATA';
export const SET_KEYWORD = 'SET_KEYWORD';
export const GET_STATION_DATA = 'GET_STATION_DATA';
export const GET_CITY_DATA = 'GET_CITY_DATA';
export const COMPANY_LOOKUP_DATA_SUCCESS = 'COMPANY_LOOKUP_DATA_SUCCESS';
export const LOAD_MORE_COMPANY_LOOKUP_DATA = 'LOAD_MORE_COMPANY_LOOKUP_DATA';
export const CHANGE_VIEW_WITH_RESULT = 'CHANGE_VIEW_WITH_RESULT';

export const SAVE_ADMIN_COMMENTS = 'SAVE_ADMIN_COMMENTS';
export const FETCH_USER_FUNCTIONS = 'FETCH_USER_FUNCTIONS';
export const MANAGE_NAVIGATE_BACK='MANAGE_NAVIGATE_BACK';

export const USER_PRIMARY_FUNCTIONS = 'USER_PRIMARY_FUNCTIONS';

export const QF_ADMIN = 'QF_ADMIN';
export const CUSTOMER_ADMIN = 'CUSTOMER_ADMIN';
export const REFRESH_ADDITIONAL_INFO = 'REFRESH_ADDITIONAL_INFO';
export const AUTHORISE_SUCCESS_MESSAGE = 'New user is successfully authorised.';
export const MANAGE_SUCCESS_MESSAGE = 'Changes to user are successfully saved.';
export const GET_COLLEAGUE_INFO = 'GET_COLLEAGUE_INFO';
export const FUNC_ROLE_CURRENT_QF_CUSTOMER = "CURRENT_QF_CUSTOMER";
export const FUNC_ROLE_OTHER = "OTHER";
export const FUNC_ROLE_GROUND_HANDLER = "GROUND_HANDLER";
export const INTPORCUS = "INTPORCUS";
export const MANAGE_USERS = "MANAGE_USERS";
export const AUTHORIZE_USERS = "AUTHORIZE_USERS";
export const RATES_INTERNAL = "RATES_INTERNAL";

export const DELETE_DIALOG_CONFIRM_LABEL = "Delete";

export const LANDING_VIEW = "LANDING_VIEW";
export const ADD_PCA_VIEW = "ADD_PCA_VIEW";
export const DELETE_ADHOC_PCA = "DELETE_ADHOC_PCA";
export const ADHOC_PCAS_SEARCH = "ADHOC_PCAS_SEARCH";

export const HIDE_SUCCESS_MESSAGE = "HIDE_SUCCESS_MESSAGE";
export const SET_PCA_DATE = "SET_PCA_DATE";
export const SET_PCA_REF = "SET_PCA_REF";
export const PCA_RANGE = 28;
export const SET_PCA_DATE_ERROR = "SET_PCA_DATE_ERROR";
export const DROP_DOWN_SELECT="DROP_DOWN_SELECT";
export const SET_SORT_ORDER = "SET_SORT_ORDER";
export const SET_SORT_FIELD = "SET_SORT_FIELD";
export const SET_CURRENT_PCA = 'SET_CURRENT_PCA';
export const GET_SEARCHED_AIRPORTS_SUCCESS = "GET_SEARCHED_AIRPORTS_SUCCESS";
export const UPDATE_AIRPORTS="UPDATE_AIRPORTS";
export const RETRIEVE_PCA="RETRIEVE_PCA";
export const GET_COMPANY_INFO="GET_COMPANY_INFO";
export const GET_PERSONAL_INFO="GET_PERSONAL_INFO";
export const APPROVE_ADHOC_PCA="APPROVE_ADHOC_PCA";
export const REJECT_ADHOC_PCA="REJECT_ADHOC_PCA";
export const AUTHORISE_VIEW="AUTHORISE_VIEW";
export const APPROVE_VIEW="APPROVE_VIEW";
export const REJECT_VIEW="REJECT_VIEW";
export const POST_ADHOC_PCAS="POST_ADHOC_PCAS";
export const GET_AWB_DATA="GET_AWB_DATA";
export const GET_MORE_DATA="GET_MORE_DATA";
export const DAY_IN_MS="86400000"
export const SET_PCA_DATE_RANGE="SET_PCA_DATE_RANGE";
export const CLEAR_FILTERS="CLEAR_FILTERS";
export const SET_SEARCH_MESSAGE="SET_SEARCH_MESSAGE";
export const fromToValidRegex = /^[a-zA-Z]{3}$/;
export const mandatoryRegex =/^\s*$/;
/**
 * Global Constants
 */

export const SHOW_APP_ERROR = "SHOW_APP_ERROR";
export const HIDE_APP_ERROR = "HIDE_APP_ERROR";
export const TOGGLE_LOADER = "TOGGLE_LOADER";
